import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone, MessageCircle, Calendar } from "lucide-react";
import { BRAND, waLink } from "@/data/site";

const FloatingActions = () => (
  <>
    <motion.a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-24 right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.35)] md:bottom-6 md:right-6"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.4, type: "spring", stiffness: 200 }}
      data-testid="whatsapp-float"
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-20" aria-hidden="true" />
      <MessageCircle size={26} className="relative" />
    </motion.a>

    <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-white/10 bg-black/92 backdrop-blur-xl md:hidden" data-testid="mobile-action-bar">
      <a
        href={BRAND.phoneLink}
        className="flex items-center justify-center gap-2 py-4 font-display text-[11px] font-extrabold uppercase tracking-[0.14em] text-white"
        data-testid="mobile-bar-call"
      >
        <Phone size={16} className="text-red-500" /> Call
      </a>
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 border-x border-white/10 py-4 font-display text-[11px] font-extrabold uppercase tracking-[0.14em] text-white"
        data-testid="mobile-bar-whatsapp"
      >
        <MessageCircle size={16} className="text-emerald-400" /> WhatsApp
      </a>
      <Link
        to="/booking"
        className="flex items-center justify-center gap-2 bg-gradient-to-r from-red-600 to-rose-700 py-4 font-display text-[11px] font-extrabold uppercase tracking-[0.14em] text-white"
        data-testid="mobile-bar-book"
      >
        <Calendar size={16} /> Book
      </Link>
    </div>
  </>
);

export default FloatingActions;
